module.exports = __webpack_public_path__ + "media/images/admin2/AdminAgenciesDetails__table__col__a-header-cbd5ad63c668b94c38cc1d08db2d2c13.svg";